"use client";
import { useState } from "react";
import { Drawer, Image } from "antd";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import { ToastContainer, toast } from "react-toastify";
import CommonImage from "@/components/common/image/CommonImage";
import { useDispatch, useSelector } from "react-redux";
import { closeDrawer } from "@/redux/slices/authDrawerSlice";
import { usePathname } from "next/navigation";

const AuthDrawer = () => {
  const dispatch = useDispatch();
  const pathName = usePathname();

  const { drawerOpen, drawerType } = useSelector((state) => state.authDrawer);

  return (
    <Drawer
      title={null}
      placement="right"
      onClose={() => dispatch(closeDrawer())}
      open={drawerOpen}
      size="large"
      className="custom-login-drawer"
      width={612}
    >
      <ToastContainer />

      <div className="form-tittle">
        <CommonImage
          src={"/images/login/welcome.avif"}
          className="welcome-title"
          alt="Login Image"

        />
        <h1 className="title">
          FOCUS — বাংলাদেশের একটি বিশ্বস্ত একাডেমিক কোচিং সেন্টার
        </h1>
      </div>

      <div className="login-registation-card">
        <div className="top-title">
          <CommonImage
            src={"/images/login/login-title.avif"}
            className="top-icon"
            alt="Icon Image"
          />
          <span className="text-[#2e4e8d] [.dark_&]:text-d-white font-medium text-sm">
            {drawerType === "login" ? "লগইন" : "রেজিস্ট্রেশন"}
          </span>
        </div>

        <div className="">
          {drawerType === "login" ? (
            <LoginForm
              toast={toast}
              setDrawerOpen={() => dispatch(closeDrawer())}
              pageType=""
              pathName={pathName}
            />
          ) : (
            <RegisterForm
              toast={toast}
              setDrawerOpen={() => dispatch(closeDrawer())}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default AuthDrawer;
